// authProvider.js
import { MsalAuthProvider, LoginType } from "react-aad-msal"
import { Logger, LogLevel } from "msal"
import UAI from "./UAI"

export const authProvider = new MsalAuthProvider(
  {
    auth: {
      authority:
        "https://login.microsoftonline.com/1493756b-9ee3-4b7e-85fb-a1a7ece5c165",
      clientId: "a6a9a45c-68c3-436f-9401-25cfab6f627c",
      postLogoutRedirectUri: window.location.origin,
      redirectUri: UAI.wwwroot() + "/",
      validateAuthority: true,

      // After being redirected to the "redirectUri" page, should user
      // be redirected back to the Url where their login originated from?
      navigateToLoginRequestUrl: false,
    },
    // Enable logging of MSAL events for easier troubleshooting.
    // This should be disabled in production builds.
    system: {
      logger: new Logger(
        (logLevel, message, containsPii) => {
          console.log("[MSAL]", message)
        },
        {
          level: LogLevel.Info,
          piiLoggingEnabled: false,
        }
      ),
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true,
    },
  },
  {
    scopes: ["openid", "user.read"],
  },
  {
    loginType: LoginType.Redirect,
    // When a token is refreshed it will be done by loading a page in an iframe.
    // Rather than reloading the same page, we can point to an empty html file which will prevent
    // site resources from being loaded twice.
    tokenRefreshUri: UAI.wwwroot() + "/auth.html",
  }
)
